<div class="select-list {{selectedType}}" [attr.data-test]="formCtrlName||'select'" [class.binary]="isBinary" [class.multiple]="allowMultiple">
  <ul>
    <li *ngFor="let option of options" [attr.data-test]="option"  [class.active]="checkActive(option)" (click)="change(option)">
      <fa-icon class="check" [icon]="icons.check"></fa-icon>
      <span>{{option }}</span>
    </li>
  </ul>
</div>